/**
 * Map viewport URL state: Zod schema + plain URL read/write.
 *
 * Uses native history.replaceState (not React Router) so URL updates
 * don't trigger React re-renders or add browser history entries.
 *
 * URL params: ?lat=37.7750&lng=-122.4195&zoom=12.0
 */
import { z } from 'zod';

export const MapViewportSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  zoom: z.number().min(0).max(22),
});

/** Parse viewport from the current URL. Returns null when params are absent/invalid. */
export const readMapViewport = () => {
  const p = new URLSearchParams(window.location.search);
  const result = MapViewportSchema.safeParse({
    lat: parseFloat(p.get('lat')),
    lng: parseFloat(p.get('lng')),
    zoom: parseFloat(p.get('zoom')),
  });
  return result.success ? result.data : null;
};

/** Write viewport to URL without triggering a React Router navigation. */
export const writeMapViewport = ({ lat, lng, zoom }) => {
  const url = new URL(window.location.href);
  url.searchParams.set('lat', String(Math.round(lat * 10000) / 10000));
  url.searchParams.set('lng', String(Math.round(lng * 10000) / 10000));
  url.searchParams.set('zoom', String(Math.round(zoom * 10) / 10));
  window.history.replaceState(window.history.state, '', url.toString());
};
